import React, { useState } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import SbEditable from 'storyblok-react';
import InfiniteScroll from 'react-infinite-scroller';
import moment from 'moment';

import LinkWrap from '../link_wrap';
import './press-timeline.scss';

const monthShortNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const PressReleaseTimelineItem = (props) => {
  const itemClasses = ['timeline-item'];

  if (!props.showDate) {
    itemClasses.push('no-date');
  }

  const url = props.data.field_link_url_string || `/${props.data.full_slug}`;

  return (
    <div class={itemClasses.join(' ')}>
      <h4>
        <LinkWrap to={url} openInNewWindow={!!props.data.field_link_url_string}>
          {props.data.field_title_string}
        </LinkWrap>
      </h4>
      <h5>{props.data.field_publisher_string || 'Swell Energy'} - {props.showDate && <>{moment(props.data.field_publish_date_string).format('MMM yyyy')}</>}</h5>
      <p>{props.data.field_short_description_string}</p>
    </div>
  );
};

const PressTimeline = (props) => {
  const [items, setItems] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const showDates = props.blok.show_dates;
  const title = props.blok.title || 'Press Timeline';

  const loadNextPage = () => {
    const nextChunk = props.data.slice(pageNumber * 10, (pageNumber + 1) * 10);
    setItems([].concat(items).concat(nextChunk));
    setPageNumber(pageNumber + 1);
  };

  return (
    <SbEditable content={props.blok}>
      <section className="press-timeline-wrapper">
        <div className="press-timeline">
          <h3>{title}</h3>
          {/* {props.data && props.data.map((item) => <PressReleaseTimelineItem key={item.node.id} data={item.node} showDate={showDates}></PressReleaseTimelineItem>)} */}
          <InfiniteScroll
            pageStart={0}
            loadMore={loadNextPage}
            hasMore={items.length < props.data.length}
          >
            {items.map((item) => (
              <PressReleaseTimelineItem
                key={item.node.id}
                data={item.node}
                showDate={showDates}
              ></PressReleaseTimelineItem>
            ))}
          </InfiniteScroll>
        </div>
      </section>
    </SbEditable>
  );
};
//export default PressTimeline

export default (props) => (
  <StaticQuery
    query={graphql`
      {
        allStoryblokEntry(
          filter: { field_component: { regex: "/(press_release)|(press_news_mention)/" } }
          sort: { fields: field_publish_date_string, order: DESC }
        ) {
          edges {
            node {
              id
              field_title_string
              full_slug
              field_publisher_string
              field_publish_date_string
              field_short_description_string
              field_link_url_string
            }
          }
        }
      }
    `}
    render={(data) => <PressTimeline data={data.allStoryblokEntry.edges} {...props} />}
  />
);
